(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracAdminCustomerAccount', NasracAdminCustomerAccount);

    NasracAdminCustomerAccount.$inject = ['$resource', 'DateUtils'];

    function NasracAdminCustomerAccount ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-admin-customer-accounts/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.launchDate = DateUtils.convertDateTimeFromServer(data.launchDate);
                    }
                    return data;
                }
            },'download' : {
                method : 'GET',
                url : 'api/nasrac-admin-customer-accounts/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
